/**
 * Czech needs three forms: 1, 2–4, and everything else (0 and 5+).
 * `czechPlural(3, ['úlohu', 'úlohy', 'úloh'])` → `'úlohy'`.
 */
export function czechPlural(count: number, [one, few, many]: readonly [string, string, string]): string {
  if (count === 1) return one
  if (count >= 2 && count <= 4) return few
  return many
}
